<template>
  <div>
    <ul class="mt-16 md:mt-0">
      <li
        v-for="sitterSkeleton in sitterSkeletonArray"
        :key="sitterSkeleton"
        class="w-full shadow-none sm:border-b-1 border-grey-divider-subdued border-solid rounded-none last:border-b-0 px-16 pb-16 sm:p-0"
      >
        <div class="p-16 w-full flex flex-row justify-between bg-white">
          <div class="w-full max-w-64 rounded-full animate-pulse h-64 bg-grey-divider-subdued"></div>
          <div class="w-full pl-16">
            <div class="w-full h-24 mb-8 animate-pulse bg-grey-divider-subdued"></div>
            <div class="w-full h-20 mb-8 animate-pulse bg-grey-divider-subdued"></div>
            <div class="w-full h-20 mb-8 animate-pulse bg-grey-divider-subdued"></div>
            <div class="w-full h-20 mb-8 animate-pulse bg-grey-divider-subdued"></div>
            <div class="w-full h-18 mb-8 animate-pulse bg-grey-divider-subdued"></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
export default {
  name: 'ApplicationsSkeleton',
  computed: {
    sitterSkeletonArray(): number[] {
      // add skeletons based on user window height
      return Array(Math.floor(window.innerHeight / 225));
    },
  },
};
</script>

<style></style>
